import * as theme from "../theme";
import _ from "lodash";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ImportanceIconShowDecider } from "./QuestionText";
import { getNodesSum } from "../store/qf";
import { getLanguagePreference, getBrokerInformation } from "../store/broker";

const Message = ({
  text,
  node,
  handleAnswerChange,
  isNodeOpen,
  formid,
  fontSize,
  textColor,
}) => {
  const { logic } = node;
  const brokerInfo = useSelector(getBrokerInformation);
  const languagepreference =
    brokerInfo?.information?.languagepreference || "en";

  // Translation messages for both English and French
  const translationMessages = {
    en: {
      reduce: "Please reduce as the sum is greater than 100 by ",
      increase: "Please increase the percentage as ",
      missing: " points are still missing",
    },
    fr: {
      reduce: "Veuillez réduire car la somme dépasse 100 de ",
      increase: "Veuillez augmenter le pourcentage car ",
      missing: " points manquent encore",
    },
  };

  let qids = [];
  if (logic && logic.groupPercentage) {
    if (node.id.includes("_")) {
      qids = logic.groupPercentage.map(
        (x) => node.id.slice(0, node.id.lastIndexOf("_")) + "_" + x
      );
    } else {
      qids = logic.groupPercentage;
    }
  }

  const nodexx = useSelector(
    getNodesSum({ formid, questionids: qids, locationid: node.locationid })
  );

  if (text === null || text === "" || _.isEmpty(text)) return null;

  let totalSum = "";
  if (logic && nodexx > 0) {
    if (nodexx > 100)
      totalSum =
        translationMessages[languagepreference].reduce +
        (nodexx - 100) +
        translationMessages[languagepreference].missing;
    else if (nodexx < 100)
      totalSum =
        translationMessages[languagepreference].increase +
        (100 - nodexx) +
        translationMessages[languagepreference].missing;
  }

  return (
    <div
      style={{
        width: "100%",
        color: textColor ? textColor : theme.COLORS.primary_navyblue,
        paddingTop: "5vh",
        fontSize: fontSize ? fontSize : "1.9vh",
        letterSpacing: 1,
        marginBottom: "2vh",
      }}
    >
      {text + " "}
      <div
        style={{
          width: "100%",
          color: theme.COLORS.red_dot,
          paddingLeft: "1vmin",
          paddingTop: "2px",
          fontSize: "1.2vh",
          letterSpacing: 1,
        }}
      >
        {totalSum}
      </div>
      <ImportanceIconShowDecider node={node} />
    </div>
  );
};

export default Message;
